


























import Vue, { PropType } from 'vue';
import { WithRefs } from 'vue-typed-refs';

import FormElement from '../FormElement/FormElement.vue';

import type { SelectOption } from './types';

type Refs = {
  select: HTMLSelectElement;
};

export default (Vue as WithRefs<Refs>).extend({
  name: 'SldsSelect',
  components: {
    FormElement,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select an option',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    optionLabel: {
      type: String,
      default: 'label',
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/ban-types
    inputListeners(): Record<string, Function | Function[]> {
      const { input: _, change: __, ...listeners } = this.$listeners;
      return listeners;
    },
    hasPlaceholderOption(): boolean {
      return (
        this.options.length === 1 ||
        this.options.find(
          (option) =>
            option[this.optionValue] === undefined ||
            option[this.optionValue] === null
        ) === undefined
      );
    },
  },
  watch: {
    value(value: string | number) {
      this.localValue = value;
    },
    localValue(value: string | number) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
  methods: {
    getSelect(): HTMLSelectElement {
      return this.$refs.select;
    },
  },
});
